import axios from 'axios'

const baseURL = process.env.VUE_APP_URL_API
const route = `${baseURL}public`

export default {
  namespaced: true,

  state: {
    bookingEnabled: false,
    availableRooms: [],
    selectedCategory: null,
    searchParams: null,
  },
  getters: {
    bookingEnabled: state => state.bookingEnabled,
    availableRooms: state => state.availableRooms,
    selectedCategory: state => state.selectedCategory,
    searchParams: state => state.searchParams,
  },
  mutations: {
    SET_BOOKING_ENABLED(state, enabled) {
      state.bookingEnabled = enabled
    },
    SET_AVAILABLE_ROOMS(state, rooms) {
      state.availableRooms = rooms
    },
    SET_SELECTED_CATEGORY(state, category) {
      state.selectedCategory = category
    },
    SET_SEARCH_PARAMS(state, params) {
      state.searchParams = params
    },
  },
  actions: {

    isRegistered(context, data) {
      return axios.post(`${route}/is_registered`, data)
    },
    get_countries() {
      return axios.get(`${route}/get_countries`)
    },
    get_states() {
      return axios.get(`${route}/get_states`)
    },
    get_cities(context, state_code) {
      return axios.get(`${route}/get_cities/${state_code}`)
    },
    register_guest(context, data) {
      return axios.post(`${route}/register_guest`, data)
    },
    validate_reserve(context, data) {
      return axios.post(`${route}/validate_reserve`, data)
    },
    get_reserve_info(context, data) {
      return axios.post(`${route}/pre-checkin/reserve-info`, data)
    },
    submit_precheckin(context, data) {
      return axios.post(`${route}/pre-checkin/submit`, data)
    },
    update_guest(context, data) {
      return axios.post(`${route}/update_guest`, data)
    },

    // Booking Engine Actions
    async checkBookingStatus({ commit }) {
      try {
        const response = await axios.get(`${route}/booking/status`)
        commit('SET_BOOKING_ENABLED', response.data.enabled)

        return response
      } catch (error) {
        commit('SET_BOOKING_ENABLED', false)
        throw error
      }
    },

    async searchAvailability({ commit }, params) {
      try {
        const response = await axios.post(`${route}/booking/availability`, params)
        if (response.data.success) {
          commit('SET_AVAILABLE_ROOMS', response.data.data)
          commit('SET_SEARCH_PARAMS', response.data.search_params)
        }

        return response
      } catch (error) {
        commit('SET_AVAILABLE_ROOMS', [])
        throw error
      }
    },

    async createReservation({ commit }, data) {
      return axios.post(`${route}/booking/reservation`, data)
    },

    async getPaymentStatus({ commit }, paymentId) {
      return axios.get(`${route}/booking/payment/${paymentId}`)
    },

    selectCategory({ commit }, category) {
      commit('SET_SELECTED_CATEGORY', category)
    },

    resetBooking({ commit }) {
      commit('SET_AVAILABLE_ROOMS', [])
      commit('SET_SELECTED_CATEGORY', null)
      commit('SET_SEARCH_PARAMS', null)
    },

  },
}
